export default __webpack_public_path__ + "static/media/sa.f9dacb2d.svg";